<div class="container-navbar">
    <!-- Ghost Mode Indicator -->
    <div class="ghost-mode-banner" *ngIf="isGhostSession">
        <div class="ghost-mode-content">
            <i class="pi pi-user" style="font-size: 1.2rem;"></i>
            <span class="ghost-mode-text">
                <strong>Ghost Mode:</strong> You are logged in as <strong>{{ ghostUserName }}</strong>
            </span>
        </div>
        <button class="ghost-mode-exit-btn" (click)="exitGhostSession()">
            <i class="pi pi-sign-out" style="font-size: 1rem; margin-right: 6px;"></i>
            Exit Ghost Session
        </button>
    </div>
    <div class="navbar">
        <div class="notification-banner" *ngIf="showNotificationBanner && numberOfUnreadMessages > 0 && !isGhostSession">
            <div class="notification-banner-content" (click)="goToNotifyPage()">
                <div class="banner-icon-wrapper">
                    <img src="./assets/images/icons-navbar/ic-notification.svg" alt="notification icon" class="notification-banner-icon">
                    <div class="banner-badge">{{numberOfUnreadMessages}}</div>
                </div>
                <span class="notification-banner-text">
                    <strong>New Notifications:</strong> Click here to view your new notifications.
                </span>
            </div>
            <span
                class="notification-banner-close"
                role="button"
                tabindex="0"
                (click)="dismissNotificationBanner()"
                (keydown.enter)="dismissNotificationBanner()"
                (keydown.space)="dismissNotificationBanner()"
                aria-label="Close notification banner"
            >x</span>
        </div>
        <div  class="header">
            <img *ngIf="leftArrowRoute" (click)="backRoute()" src="./assets/images/ic-arrow-left.png" alt="ic-arrow-left">
            <h2 *ngIf="header" [ngStyle]="titleStyle" class="title">{{header}}</h2>
        </div>
        <!-- <div *ngIf="!isMainDomain" class="header search-bar">
            <img src="./assets/images/icon-search.svg" alt="search-icon">
            <p-autoComplete #searchName class="form-control" [placeholder]="placeholderValue" [disabled]="!searchEnabled" (onSelect)="onSuggestionSelect($event)"  [field]="fieldValue" [suggestions]="suggestions" (completeMethod)="search($event)">
            </p-autoComplete>

            <div class="dropdown-content">
                <p-dropdown  [ngClass]="'category'" placeholder="Select Module" [(ngModel)]="selectModule" [options]="modules" optionLabel="name" (onChange)="getModuleName($event)"></p-dropdown>
            </div>
        </div> -->
        <div class="right-section">
            <div *ngIf="!isMainDomain" class="notification position-relative">
                <div *ngIf="numberOfUnreadMessages && !isLoadingNotify" class="notification-number">{{numberOfUnreadMessages > 99 ? '+99' : numberOfUnreadMessages}}</div>
                <div *ngIf="isLoadingNotify" class="notification-number" style="min-width: 16px;width: 16px;height: 16px;top: -5px;"></div>
                <!-- (click)="notificationShow = !notificationShow" -->
                <img id="notifications-btn" src="./assets/images/icons-navbar/ic-notification.svg" (click)="openNotifyPopup()" alt="ic-notification">
            </div>
            <!-- <div class="app-builder">
                <img src="./assets/images/icons-navbar/ic-app_builder.svg" alt="ic-app_builder">
            </div>
            <div class="printer">
                <img src="./assets/images/icons-navbar/ic-print.svg" alt="ic-print">
            </div>
            <div class="helper" (click)="progressBarPopup=true">
                <span>HELP</span>
                <img src="./assets/images/icons-navbar/ic-chevron.svg" class="down-arrow" alt="ic-chevron">
            </div> -->
            <div class="account-info" *ngIf="!isCircle">
                <img *ngIf="!avatar" src="./assets/images/icons-navbar/ic-profile.svg" class="profile-icon" alt="ic-profile">
                <img *ngIf="avatar" style="margin-right: 10px;" [src]="avatar" class="avatar" alt="avatar">
                <span class="account-name">{{(userObj?.first_name + ' ' + userObj?.last_name)|titlecase}}</span>
                <img src="./assets/images/icons-navbar/ic-chevron.svg" class="down-arrow" alt="ic-chevron" (click)="showProfileMenu()">
                <div class="account-info-tab">
                    <ul>
                        <li class="nav-item"><a class="nav-link" (click)="goToMyAccount()">My Account</a></li>
                        <li class="nav-item"><a class="nav-link" (click)="openConfirm()">Logout</a></li>
                    </ul>
                </div>
            </div>
            <div class="account-info circle" *ngIf="isCircle">
                <div class="icon">
                    <img *ngIf="!avatar" src="./assets/images/icons-navbar/ic-profile.svg" class="profile-icon" alt="ic-profile">
                    <img *ngIf="avatar" [src]="avatar" class="avatar" alt="avatar">
                </div>
                <img src="./assets/images/icons-navbar/ic-chevron.svg" class="down-arrow" alt="ic-chevron" (click)="showProfileMenu()">
                <div class="account-info-tab">
                    <ul>
                        <li class="nav-item"><a class="nav-link" (click)="goToMyAccount()">My Account</a></li>
                        <li class="nav-item"><a class="nav-link" (click)="openConfirm()">Logout</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- notifications -->
        <div [hidden]="!notificationShow" class="notification-body notif-panel">
            <div class="notif-head">
                <div class="notif-head-left">
                    <span class="notif-title">Notifications</span>
                    <span *ngIf="numberOfUnreadMessages" class="notif-badge">
                        {{ getUnreadCountLabel() }} new
                    </span>
                </div>
                <button class="notif-markread" type="button" (click)="makeAllAsRead()" [disabled]="loadingSubmit || !numberOfUnreadMessages">
                    <span>Mark all read</span>
                    <i *ngIf="loadingSubmit" class="fa-spin fas fa-spinner ms-1"></i>
                </button>
            </div>

            <div *ngIf="!isLoadingNotify" class="notif-list">
                <button
                    *ngFor="let message of messagesList"
                    class="notif-item unread allow-tall-button"
                    type="button"
                    (click)="notificationDetails(message)"
                >
                    <span class="notif-icon" [ngClass]="getNotificationTone(message)">
                        <app-icon *ngIf="!message?.icon" [name]="getNotificationIcon(message)" [size]="19" [strokeWidth]="2"></app-icon>
                        <img *ngIf="message?.icon" [src]="message?.icon" alt="">
                    </span>
                    <span class="notif-body">
                        <span class="notif-row1">
                            <span class="notif-itemtitle">{{ getNotificationTitle(message) }}</span>
                            <span class="notif-when">
                                <app-icon name="clock" [size]="11" [strokeWidth]="2.4"></app-icon>
                                {{ getNotificationTime(message) }}
                            </span>
                        </span>
                        <span *ngIf="getNotificationReference(message)" class="notif-cid">
                            {{ getNotificationReference(message) }}
                        </span>
                        <span class="notif-text">{{ message?.body }}</span>
                    </span>
                </button>

                <div *ngIf="!messagesList.length" class="no-message">
                    <span class="no-message__icon">
                        <app-icon name="bell" [size]="22" [strokeWidth]="1.8"></app-icon>
                    </span>
                    <span>No unread notifications.</span>
                </div>
            </div>

            <div *ngIf="isLoadingNotify" class="notif-list">
                <div *ngFor="let item of loadingSchema" class="notif-item notif-item--loading unread">
                    <div class="notif-icon">
                        <ngx-skeleton-loader appearance="line" [theme]="{
                            'border-radius': '11px',
                            'height': '38px',
                            'width': '38px',
                            'background': '#f3eefe',
                            'margin': 0
                        }"></ngx-skeleton-loader>
                    </div>
                    <div class="notif-body">
                        <ngx-skeleton-loader appearance="line" [theme]="{
                            'border-radius': '6px',
                            'height': '15px',
                            'max-width': '210px',
                            'background': '#f1f3f6',
                            'margin': '0 0 8px'
                        }"></ngx-skeleton-loader>
                        <ngx-skeleton-loader appearance="line" [theme]="{
                            'border-radius': '6px',
                            'height': '12px',
                            'max-width': '140px',
                            'background': '#f4f5f7',
                            'margin': '0 0 7px'
                        }"></ngx-skeleton-loader>
                        <ngx-skeleton-loader appearance="line" [theme]="{
                            'border-radius': '6px',
                            'height': '13px',
                            'max-width': '250px',
                            'background': '#f1f3f6',
                            'margin': 0
                        }"></ngx-skeleton-loader>
                    </div>
                </div>
            </div>

            <div class="notif-foot">
                <button type="button" (click)="goToNotifyPage()">View all notifications</button>
                <button type="button" (click)="goToSettingsNotify()">Settings</button>
            </div>
        </div>
        <div [hidden]="!notificationShow" class="layout" (click)="notificationShow = !notificationShow;hasNewMessageReceived=false"></div>
    </div>
</div>
<div class="overlay-navbar" (click)="closeProfileMenu()"></div>

<!-- confirmation message -->
<app-confirmation-msg
#messageComponent
[isLoading] = 'loadingSubmit'
(accepted)="accepted()"
(rejected)="rejected()"
[centerOfScreen]="true"
[headerMessage]="'Confirmation Message'"
[bodyMessage] = "'Do you want to logout from the system?'">
</app-confirmation-msg>

<!-- Exit Ghost Session Confirmation -->
<app-confirmation-msg
  class="conformation"
  #exitGhostConfirmComponent
  [isLoading]="false"
  (accepted)="confirmExitGhostSession()"
  (rejected)="exitGhostConfirmComponent.close()"
  [headerMessage]="'Exit Ghost Session'"
  [bodyMessage]="'Are you sure you want to exit ghost session and return to your main account?'"
>
</app-confirmation-msg>
